import { render } from "./TimeSlotItemChild.vue?vue&type=template&id=1f4584e6&scoped=true&ts=true"
import script from "./TimeSlotItemChild.vue?vue&type=script&lang=ts"
export * from "./TimeSlotItemChild.vue?vue&type=script&lang=ts"

import "./TimeSlotItemChild.vue?vue&type=style&index=0&id=1f4584e6&lang=scss&scoped=true"

import exportComponent from "/builds/spark/services/frontend/admin-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f4584e6"]])

export default __exports__